export default "__VITE_PUBLIC_ASSET__a11b1a1c__"